<template>
    <div class="warehouse-list">
        <Table
            max-height="400"
            class="margin-15"
            size="small"
            border
            :columns="columns"
            :data="warehouseList"
        ></Table>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: ["warehouseType", "orgWarehouseIds"],
    data() {
        return {
            warehouseList: [],
        };
    },

    watch: {
        getWarehouseList: {
            immediate: true,
            handler(val) {
                // 全部
                if (this.warehouseType == 1) {
                    console.log(this.getWarehouseList);
                    this.warehouseList = this.getWarehouseList
                        .filter((item) => {
                            return (
                                item.attach.warehouseType === 1 ||
                                item.attach.warehouseType === 5
                            );
                        })
                        .map((item) => {
                            let active =
                                item.attach.active === 0 ? "(失效)" : "";
                            return {
                                code: item.attach.code,
                                title: item.label.replace(item.attach.code, '').replace('(', '').replace(')', '') + active,
                            };
                        });
                }
                // 指定仓库
                else if (this.warehouseType == 0) {
                    console.log(this.getWarehouseList);
                    this.warehouseList = this.getWarehouseList
                        .filter((item) => {
                            let orgWarehouseIds =
                                this.orgWarehouseIds.split(",");
                            for (let i = 0; i < orgWarehouseIds.length; i++) {
                                if (item.value == orgWarehouseIds[i])
                                    return item;
                            }
                        })
                        .map((item) => {
                            let active =
                                item.attach.active === 0 ? "(失效)" : "";
                            return {
                                code: item.attach.code,
                                title: item.label.replace(item.attach.code, '').replace('(', '').replace(')', '') + active,
                            };
                        });
                }
            },
        },
    },

    created() {
        console.log(this.warehouseType, this.orgWarehouseIds);
    },
    computed: {
        ...mapGetters("dictionary", ["getWarehouseList"]),
        columns() {
            return [
                {
                    title: "仓库代码",
                    key: "code",
                },
                {
                    title: "仓库名称",
                    key: "title",
                },
            ];
        },
    },
};
</script>

<style>
</style>
